import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import ApiClient from '../components/common/ApiClient';

const CheckpaymentOtt = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { getRequest } = ApiClient();
    const { id = null, response = null } = useParams();
        const [loading, setLoading] = useState(true);
    const [ottData, setOttData] = useState(null);


    useEffect(() => {
   
        const loadPreOttData = async () => {
            if (id) {
                try {
                    const response1 = await getRequest(`ott/${id}`, {});
                    // console.log('response', response1.data)
                    setOttData(response1.data);
                    return response1.data;
                } catch (error) {
                    console.error('Error fetching data:', error);
                    throw error;
                }
            } 
            
        };


        const checkOttPaymentStatus = async () => {
            try {
                const dataott = await loadPreOttData();
        // console.log('Ott', dataott.step)

                if (dataott.step >= 8) {
                    setLoading(false);
                } else {
                    navigate('/dashboard');
                }
              
            } catch (error) {
                console.error('Error checking payment status:', error);
                navigate('/dashboard');
            }
        };


        checkOttPaymentStatus();
    }, [navigate, location, id]);
    

    if (loading) {
        return <div>Loading...</div>; // or a spinner
    }

    return children;
};

export default CheckpaymentOtt;
